import React from 'react';
import { forgotPassword } from "../../util/user";
import socks from '../../images/main1.jpg';
import logo from '../../images/new_logo.svg';
import poop_5 from '../../images/main1.jpg';

export default class Forgot extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: ""
    }

    this.forgotPasswordAction = this.forgotPasswordAction.bind(this)
    this.hideErrorCtn = this.hideErrorCtn.bind(this)
  }

  forgotPasswordAction() {
    const state = this;

    forgotPassword(this).then(() => {
      state.setState({
        errorMessage: "Success"
      });
    });
  }

  hideErrorCtn() {
    this.setState({
      errorMessage: undefined
    });
  }

  handleEmailChange(e) {
    this.setState({ email: e.target.value });
  }

  render() {
    const error = this.state.errorMessage;
    let errorDetail = <div></div>

    if (error !== undefined) {
        errorDetail = <div onClick={this.hideErrorCtn} className="notification-ctn error">
          {error}
        </div>
    }

    return (
    <div className="two-pane">
      <div className="right-side yellow-bg account-inputs">
        <div className="cta-account">
          <div className="top">
            <img className="logo" src={logo} alt="Logo"/>
            <h3>The best Hamilton Homes for you</h3>
          </div>
          <div className="bottom">
            We have the best homes for you! Make an account to see full details
          </div>
        </div>

        <input
        value={this.state.email}
        onChange={ this.handleEmailChange.bind(this) }
        placeholder="Email" />

        <br/>
        <button className="submit-post" onClick={this.forgotPasswordAction}>Reset Your Password</button>

        <div className="submit-post" onClick={this.props.changeUserContext}>Don't have an account? <span className="yellow-font">Signup instead</span></div>
      </div>

      <div className="left-side">
        <img className="socks" src={socks} alt="No Pants No Problem"/>
      </div>

      {errorDetail}
    </div>
  )}
}
